import { SVGProps } from 'react';

const Anchor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 22V8m0 14A10 10 0 0 1 2 12h3m7 10a10 10 0 0 0 10-10h-3m-7-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
    />
  </svg>
);
export default Anchor;
